// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

const myCustomTheme = {
  dark: false,
  colors: {
    primary: "#2B5C9F",
    info: "#2B5C9F"
  }
};

export default createVuetify(
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  {
    theme: {
      defaultTheme: "myCustomTheme",
      themes: {
        myCustomTheme,
      }
    }
  }

)
